const ArrowEnterIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props} className={`fill-current ${props?.className ? props?.className : ''}`} xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.33333 11.3334H2V2H3.33333V10H7.33333H10.6667V9.96667V7.3L14.6667 10.6333L10.6667 13.9667V11.3334H7.33333Z" fill="#9499AA"/>
  </svg>
);

export default ArrowEnterIcon;
